<script setup>
import { onMounted, onBeforeUnmount } from 'vue';
const searchBoxRef = ref(null);

function handleClickOutside(event) {
    if (searchBoxRef.value && !searchBoxRef.value.contains(event.target)) {
        closeResults();
    }
}

onMounted(() => {
    document.addEventListener('mousedown', handleClickOutside);
});

onBeforeUnmount(() => {
    document.removeEventListener('mousedown', handleClickOutside);
});
import {fromLonLat, toLonLat, transformExtent} from "ol/proj";
import Overlay from "ol/Overlay";
import {ref, watch} from 'vue'
import axios from "axios";
import TreeIcon from "@/components/icons/TreeIcon.vue";
import HomeIcon from "@/components/icons/HomeIcon.vue";


const query = ref("")
const results = ref([]);
const ids = ref([]);
const searchOverlay = ref(null);
const timer = ref(null)
const props = defineProps(["map", "toggleMap"])
const closeResults = () => {
    results.value = [];
    ids.value = [];
};

watch([query], () => {
    fetch()
})
const fetch = () => {
    if (query.value.length < 3) {
        results.value = [];
        ids.value = [];
    } else {
        if (timer.value) {
            clearTimeout(timer.value);
            timer.value = null;
        }
        timer.value = setTimeout(() => {
            axios
                .post("/api/search", {
                    search: query.value,
                })
                .then((response) => {
                    results.value = response.data.search ?? [];
                    ids.value = response.data.trees ?? [];
                })
                .catch((error) => {
                    console.log(error);
                });
        }, 500);
    }
}
const onSearchItemSelected = (item) => {
    var zoom = props.map.getView().getResolutionForZoom(19);
    zoomTo(parseFloat(item.lng), parseFloat(item.lat), parseFloat(zoom));
    query.value = "";
    results.value = [];
    ids.value = [];
}
const zoomTo = (lng, lat, zoom) => {
    if (searchOverlay.value) {
        props.map.removeOverlay(searchOverlay.value);
    }
    props.map.getView().setCenter(fromLonLat([lng, lat], "EPSG:3857"));
    props.map.getView().setResolution(zoom);

    var elem = document.createElement("div");
    elem.setAttribute("class", "pulse-point pulse-search");

    searchOverlay.value = new Overlay({
        element: elem,
        position: fromLonLat([lng, lat], "EPSG:3857"),
        positioning: "center-center",
    });
    props.map.addOverlay(searchOverlay.value);

    setTimeout(() => {
        props.map.updateSize();
    }, 800);

    setTimeout(() => {
        if (searchOverlay.value) {
            props.map.removeOverlay(searchOverlay.value);
        }
    }, 12800);
}
</script>
<template>
    <div>
        <div
            class="absolute z-10 flex justify-between w-full pt-1 pl-8 pointer-events-none"
        >
            <div
                ref="searchBoxRef"
                class="z-10 mt-1 ml-2 bg-white border rounded-lg shadow-xl border-slate-400"
                style="width: 350px"
            >
                <input
                    type="text"
                    class="pl-2 pointer-events-auto form-control no-box-shadow"
                    placeholder="Search"
                    aria-describedby="basic-addon1"
                    v-model="query"
                />
                <div
                    v-show="results.length > 0 || ids.length > 0"
                    class="pointer-events-auto"
                >
                    <div
                        class="px-2 py-1 result-item"
                        v-for="(result, index) in ids"
                        :key="index"
                        @click="onSearchItemSelected(result)"
                    >
                        <p v-if="result.type === 'Address'" class="flex flex-row items-center p-0 m-0">
                            <HomeIcon class='px-1' color="blue" />
                            {{ result.name }}
                        </p>
                        <p v-else class="flex flex-row items-center p-0 m-0 text-black">
                            <TreeIcon class="px-1"/>
                            {{ result.type }}:
                            <strong>{{ result.name }}</strong>
                        </p>
                    </div>
                    <!-- <div v-if="ids.length > 0" class="border-bottom"></div> -->
                    <div
                        class="px-2 py-1 text-black result-item"
                        v-for="(result, index) in results"
                        :key="(result.type === 'Address' ? 'address_' : 'tree_') + index"
                        @click="onSearchItemSelected(result)"
                    >
                        <p v-if="result.type === 'Address'" class="flex flex-row items-center p-0 m-0">
                            <HomeIcon class='px-1' color="blue" />

                            {{ result.name }}
                        </p>
                        <p v-else class="flex flex-row items-center p-0 m-0 text-black">
                            <TreeIcon class="px-1"/>
                            {{ result.type }}:
                            <strong>{{ result.name }}</strong>
                        </p>
                    </div>
                </div>
            </div>
            <div class="toggle">
                <button
                    @click="toggleMap()"
                    type="button"
                    class="inline-flex items-center px-3 py-2 mb-2 text-sm font-medium leading-4 border border-transparent rounded-sm shadow-sm pointer-events-auto text-slate-600 bg-slate-100 hover:bg-slate-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-500"
                >
                    <svg
                        class="w-4 h-4 mr-1 text-cool-slate-400"
                        x-description="Heroicon name: refresh"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                        ></path>
                    </svg>
                    Toggle Basemap
                </button>
            </div>
        </div>
    </div>
</template>



